module.exports = __webpack_public_path__ + "static/media/JW-marriot02.dfde1f45.jpg";